var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 109,
    viewBox: "0 0 110 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.414775
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5571 3.56946C68.5571 5.3532 67.1141 6.79929 65.3342 6.79929C63.5542 6.79929 62.1113 5.3532 62.1113 3.56946C62.1113 1.78582 63.5542 0.339844 65.3342 0.339844C67.1141 0.339844 68.5571 1.78582 68.5571 3.56946Z",
    fill: "#1439BB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1991 11.8136L41.2851 12.9209C40.9386 13.1214 40.4955 13.0024 40.2954 12.6552L36.8394 6.65639C36.6393 6.30921 36.7581 5.8652 37.1045 5.66479L39.0186 4.55731C39.365 4.3569 39.8081 4.47584 40.0082 4.82302L43.4642 10.8218C43.6643 11.1691 43.5455 11.613 43.1991 11.8136Z",
    fill: "#DF443D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8584 24.1117L11.2889 24.2581C11.7771 24.424 12.3155 24.3385 12.7287 24.0295L13.093 23.757C14.1334 22.979 15.6127 23.7342 15.5961 25.0351L15.5903 25.4906C15.5836 26.0072 15.831 26.494 16.2519 26.7922L16.6232 27.0553C17.6831 27.8065 17.4234 29.4495 16.1837 29.8357L15.7495 29.971C15.2573 30.1243 14.872 30.5106 14.719 31.0039L14.5839 31.4391C14.1986 32.6813 12.559 32.9415 11.8094 31.8794L11.5468 31.5074C11.2491 31.0856 10.7634 30.8376 10.248 30.8443L9.7933 30.85C8.49526 30.8666 7.74165 29.3844 8.51807 28.3417L8.79008 27.9765C9.0984 27.5626 9.18362 27.023 9.01805 26.5337L8.87202 26.1023C8.45514 24.8702 9.6289 23.694 10.8584 24.1117Z",
    fill: "#46AC7C"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.17818 47.041L8.66158 49.2021C8.74911 49.5933 8.50361 49.9817 8.11313 50.0693L1.36845 51.5845C0.978082 51.6721 0.590665 51.4261 0.503024 51.0349L0.0196242 48.8736C-0.0678057 48.4824 0.177695 48.0941 0.568068 48.0065L7.31285 46.4913C7.70323 46.4037 8.09064 46.6497 8.17818 47.041Z",
    fill: "#00DAB9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0754 74.5275C15.0754 76.3111 13.6325 77.7571 11.8527 77.7571C10.0727 77.7571 8.62988 76.3111 8.62988 74.5275C8.62988 72.7438 10.0727 71.2979 11.8527 71.2979C13.6325 71.2979 15.0754 72.7438 15.0754 74.5275Z",
    fill: "#F9C033"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8584 90.5244L11.2889 90.6707C11.7771 90.8365 12.3155 90.7511 12.7287 90.4421L13.093 90.1695C14.1334 89.3916 15.6127 90.1468 15.5961 91.4477L15.5903 91.9032C15.5836 92.4198 15.831 92.9066 16.2519 93.2049L16.6232 93.4678C17.6831 94.2191 17.4234 95.8621 16.1837 96.2484L15.7495 96.3836C15.2573 96.5369 14.872 96.9233 14.719 97.4166L14.5839 97.8516C14.1986 99.094 12.559 99.3542 11.8094 98.292L11.5468 97.9201C11.2491 97.4982 10.7634 97.2502 10.248 97.2568L9.7933 97.2627C8.49526 97.2793 7.74165 95.7971 8.51807 94.7545L8.79008 94.3892C9.0984 93.9751 9.18362 93.4357 9.01805 92.9464L8.87202 92.515C8.45514 91.2828 9.6289 90.1066 10.8584 90.5244Z",
    fill: "#E9EFF4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.8223 21.0306C92.8457 19.755 93.148 17.8548 94.4923 16.8212C95.8365 15.7876 97.7464 15.9866 98.723 17.2622C98.7249 17.2647 98.7266 17.2671 98.7285 17.2694",
    stroke: "#E9EFF4",
    strokeWidth: 1.25933,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.382 38.7001L102.812 38.8464C103.3 39.0124 103.839 38.9269 104.252 38.6179L104.617 38.3454C105.657 37.5673 107.136 38.3225 107.119 39.6234L107.114 40.079C107.107 40.5956 107.355 41.0823 107.775 41.3806L108.147 41.6437C109.207 42.3949 108.947 44.0379 107.707 44.4241L107.273 44.5593C106.781 44.7127 106.395 45.099 106.242 45.5923L106.107 46.0274C105.722 47.2697 104.082 47.5299 103.333 46.4677L103.07 46.0958C102.773 45.674 102.287 45.426 101.771 45.4326L101.317 45.4385C100.019 45.455 99.265 43.9728 100.042 42.9302L100.313 42.565C100.622 42.151 100.707 41.6114 100.541 41.1221L100.395 40.6907C99.9785 39.4586 101.152 38.2823 102.382 38.7001Z",
    fill: "#FFBB31"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.523 76.8999C107.714 77.1891 109.267 79.3356 108.962 81.6548C108.657 83.974 106.603 85.6446 104.412 85.3553C104.408 85.3547 104.404 85.3542 104.399 85.3537",
    stroke: "#DE3E3E",
    strokeWidth: 0.944497,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6141 104.133L96.7 105.241C96.3536 105.441 95.9105 105.322 95.7105 104.975L92.2544 98.9764C92.0544 98.629 92.1731 98.1851 92.5195 97.9847L94.4336 96.8772C94.78 96.6767 95.2231 96.7956 95.4231 97.1429L98.8792 103.142C99.0792 103.489 98.9605 103.933 98.6141 104.133Z",
    fill: "#00DAB9"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.792134
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8914 107.663C34.5458 105.906 34.9624 103.288 36.8144 101.864C38.6663 100.44 41.2975 100.714 42.643 102.471L42.6507 102.481",
    stroke: "#1439BB",
    strokeWidth: 1.25933,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7849 53.9652C91.7849 73.3253 76.1237 89.0199 56.8046 89.0199C37.4855 89.0199 21.8242 73.3253 21.8242 53.9652C21.8242 34.605 37.4855 18.9106 56.8046 18.9106C76.1237 18.9106 91.7849 34.605 91.7849 53.9652Z",
    fill: "#169560"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3662 54.0128L51.6211 64.2896L72.2496 43.6172",
    stroke: "white",
    strokeWidth: 3.00857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordSuccess);
export default __webpack_public_path__ + "static/media/passwordSuccess.fb4601da6cdee27730bf53ff1db9f20b.svg";
export { ForwardRef as ReactComponent };